import { Col, FormGroup, Input, Row } from 'reactstrap';
import { SemanticModel } from '../../../../../../../api/initiative-data-integrations';
import { BasicAlert } from '@g17eco/molecules/alert';
import { YamlError } from '../utils';
import * as YAML from 'yaml';

interface TabYamlProps {
  semanticModel: SemanticModel;
  yamlError: YamlError | null;
  handleYamlContentChange: (content: string) => void;
}

export const TabYaml = (props: TabYamlProps) => {
  const { semanticModel, yamlError, handleYamlContentChange } = props;
  const yamlContent = YAML.stringify(semanticModel);
  return (
    <div className='p-4 border rounded bg-white'>
      <Row className='mb-3'>
        <Col lg={12}>
          <h6>
            <i className='fal fa-code me-2 text-primary' />
            Raw YAML Configuration
          </h6>
          <small className='text-muted'>
            {semanticModel.name.trim() ? (
              'Edit the semantic model configuration directly in YAML or JSON format. Use caution - invalid syntax will prevent saving.'
            ) : (
              'View the semantic model configuration in YAML format. Click "Edit" to make changes.'
            )}
          </small>
        </Col>
      </Row>
      {yamlError && (
        <Row className='mb-3'>
          <Col lg={12}>
            <BasicAlert type='danger'>
              <i className='fal fa-exclamation-triangle me-2' />
              <strong>YAML Error:</strong> {yamlError.message}
              {(yamlError.line || yamlError.column || yamlError.position) && (
                <div className='mt-2 small'>
                  <strong>Location:</strong>
                  {yamlError.line && ` Line ${yamlError.line}`}
                  {yamlError.column && `, Column ${yamlError.column}`}
                  {yamlError.position && ` (Position ${yamlError.position})`}
                </div>
              )}
            </BasicAlert>
          </Col>
        </Row>
      )}
      <Row>
        <Col lg={12}>
          <FormGroup>
            <Input
              type='textarea'
              value={yamlContent}
              onChange={(e) => handleYamlContentChange(e.target.value)}
              rows={25}
              placeholder={semanticModel.name.trim() ? 'Enter YAML or JSON configuration...' : 'No configuration available'}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
};
